import { render, staticRenderFns } from "./CircleDecorator.vue?vue&type=template&id=af2d5780&scoped=true&"
import script from "./CircleDecorator.vue?vue&type=script&lang=js&"
export * from "./CircleDecorator.vue?vue&type=script&lang=js&"
import style0 from "./CircleDecorator.vue?vue&type=style&index=0&id=af2d5780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2d5780",
  null
  
)

export default component.exports